import { Nav } from "@/components/abike/Nav";
import { Hero } from "@/components/abike/Hero";
import { Problem } from "@/components/abike/Problem";
import { Solution } from "@/components/abike/Solution";
import { Environments } from "@/components/abike/Environments";
import { Experience } from "@/components/abike/Experience";
import { Vision } from "@/components/abike/Vision";
import { Founder } from "@/components/abike/Founder";
import { Inquiry } from "@/components/abike/Inquiry";
import { Footer } from "@/components/abike/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[var(--black)] text-[var(--ivory)] antialiased">
      <Nav />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <Environments />
        <Experience />
        <Vision />
        <Founder />
        <Inquiry />
      </main>
      <Footer />
    </div>
  );
}
